export const sliceResetFunctions = new Set<() => void>();

export const resetAllStores = () => {
  sliceResetFunctions.forEach((resetFn) => {
    resetFn();
  });
};
